import GetDataItemPagedListRequestModelBase from '../_generated/modelBases/get-data-item-paged-list-request-model-base';

export default class GetDataItemPagedListRequestModel extends GetDataItemPagedListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
